(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@clubajax/dates"), require("@clubajax/dom"), require("@clubajax/on"));
	else if(typeof define === 'function' && define.amd)
		define("form", ["@clubajax/dates", "@clubajax/dom", "@clubajax/on"], factory);
	else if(typeof exports === 'object')
		exports["form"] = factory(require("@clubajax/dates"), require("@clubajax/dom"), require("@clubajax/on"));
	else
		root["form"] = factory(root["@clubajax/dates"], root["@clubajax/dom"], root["@clubajax/on"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__447__, __WEBPACK_EXTERNAL_MODULE__574__, __WEBPACK_EXTERNAL_MODULE__269__) => {
return 